export default {
  slider: {
    base: {
      progress: {
        color: 'primary'
      },
      track: {
        color: 'grey-20'
      }
    }
  },
  thumb: {
    base: {
      backgroundColor: 'primary'
    }
  }
};